import { DeliveryMan } from "pages/admin/Delivery-men/DeliveryMen"
import React from "react"
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import { useTranslation } from "react-i18next"

interface DeliveryManCardProps {
  deliveryMan: DeliveryMan
  viewDetailsHandler: (deliveryMan: DeliveryMan) => void
  editDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  deleteDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  toggleActiveDeliveryMan: (deliveryMan: DeliveryMan) => void
  printDeliveredBarcodeHandler: (deliveryMan: DeliveryMan) => void
}

const DeliveryManCard: React.FC<DeliveryManCardProps> = ({
  deliveryMan,
  viewDetailsHandler,
  editDeliveryManHandler,
  deleteDeliveryManHandler,
  toggleActiveDeliveryMan,
  printDeliveredBarcodeHandler,
}) => {
  const { t } = useTranslation()

  return (
    <Col xxl="4" xl="6" md="6" sm="12">
      <Card className="text-center shadow-md">
        <CardBody className="p-0">
          <div className="card-body p-2 px-3">
            <div className="d-flex justify-content-between align-items-start p-2">
              <div className="d-flex justify-content-between align-items-start w-100">
                <div className="d-flex justify-content-start align-items-center gap-1">
                  <img
                    src="https://placehold.co/30x30/png"
                    alt="avatar"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                    }}
                  />
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <p className="mb-0 fw-semibold">{deliveryMan.name}</p>
                    <p className="mb-0 text-muted">{deliveryMan.id}</p>
                    <div className="d-flex align-items-center">
                      <i className="bx bxs-star text-warning me-1" />
                      <p className="mb-0">{deliveryMan.rate.toFixed(1)}</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start align-items-center gap-1">
                  {deliveryMan.availabilityStatus === "Available" ? (
                    <span className="badge bg-success-30 text-success fw-semibold px-2 py-1 font-size-10">
                      {deliveryMan.availabilityStatus}
                    </span>
                  ) : (
                    <span className="badge bg-primary-30 text-primary fw-semibold px-2 py-1 font-size-10">
                      {deliveryMan.availabilityStatus}
                    </span>
                  )}
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="card-drop">
                      <i className="mdi mdi-dots-vertical font-size-18"></i>
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() => editDeliveryManHandler(deliveryMan)}
                      >
                        <span className="">{t("common_edit")}</span>
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          printDeliveredBarcodeHandler(deliveryMan)
                        }
                      >
                        <span className="">
                          {t("deliveryMen_printDeliveredBarcode")}
                        </span>
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => viewDetailsHandler(deliveryMan)}
                      >
                        <span className="">{t("common_viewDetails")}</span>
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => deleteDeliveryManHandler(deliveryMan)}
                      >
                        <span className="text-danger">
                          {t("deliveryMen_deleteDeliveryMan")}
                        </span>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
              <i className="bi bi-three-dots-vertical"></i>
            </div>

            <div className="p-2 d-flex rounded-3 flex-column shadow-md align-items-start justify-content-start gap-1">
              <div className="text-muted small text-capitalize">
                {t("deliveryMen_mobileNumber")}
              </div>
              <span className="text-muted">{deliveryMan.mobileNumber}</span>
            </div>

            <div className="p-2 mt-2 d-flex rounded-3 flex-column shadow-md align-items-start justify-content-start gap-1">
              <div className="text-muted small text-capitalize">
                {t("deliveryMen_address")}
              </div>
              <span className="text-muted">{deliveryMan.address}</span>
            </div>

            <div className="form-check form-switch mt-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${deliveryMan.id}`}
                checked={deliveryMan.activeStatus === "Active"}
                onClick={() => toggleActiveDeliveryMan(deliveryMan)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${deliveryMan.id}`}
              >
                {deliveryMan.activeStatus}
              </label>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}
interface DeliveryMenGridProps {
  deliveryMen: DeliveryMan[]
  viewDetailsHandler: (deliveryMan: DeliveryMan) => void
  editDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  deleteDeliveryManHandler: (deliveryMan: DeliveryMan) => void
  toggleActiveDeliveryMan: (deliveryMan: DeliveryMan) => void
  printDeliveredBarcodeHandler: (deliveryMan: DeliveryMan) => void
}

export const DeliveryMenGrid: React.FC<DeliveryMenGridProps> = ({
  deliveryMen,
  viewDetailsHandler,
  editDeliveryManHandler,
  deleteDeliveryManHandler,
  toggleActiveDeliveryMan,
  printDeliveredBarcodeHandler,
}) => {
  return (
    <Row>
      {deliveryMen.map(deliveryMan => (
        <DeliveryManCard
          key={deliveryMan.id}
          deliveryMan={deliveryMan}
          viewDetailsHandler={viewDetailsHandler}
          editDeliveryManHandler={editDeliveryManHandler}
          deleteDeliveryManHandler={deleteDeliveryManHandler}
          toggleActiveDeliveryMan={toggleActiveDeliveryMan}
          printDeliveredBarcodeHandler={printDeliveredBarcodeHandler}
        />
      ))}
    </Row>
  )
}
